var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59994 2.7999C4.94898 2.7999 2.79996 4.94894 2.79996 7.5999C2.79996 10.2509 4.94898 12.3999 7.59994 12.3999C10.2509 12.3999 12.3999 10.2509 12.3999 7.5999C12.3999 4.94894 10.2509 2.7999 7.59994 2.7999ZM0.399963 7.5999C0.399963 3.62345 3.6235 0.399902 7.59994 0.399902C11.5764 0.399902 14.7999 3.62345 14.7999 7.5999C14.7999 9.1549 14.307 10.5948 13.4688 11.7717L19.2484 17.5514C19.7171 18.02 19.7171 18.7798 19.2484 19.2484C18.7798 19.7171 18.02 19.7171 17.5514 19.2484L11.7718 13.4688C10.5948 14.307 9.15493 14.7999 7.59994 14.7999C3.6235 14.7999 0.399963 11.5764 0.399963 7.5999Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.12c86815646af683b37d42a11fd011b8.svg";
export { ForwardRef as ReactComponent };